export default __webpack_public_path__ + "static/media/livetv.3c5839f4.svg";